export const LOCALE_LABELS = {
  'en-US': 'US English',
  'en-GB': 'British English',
};
